import React from "react";
import { Link } from "react-router-dom";

function TermsAndConditions() {
  return (
    <div style={{ padding: "20px", lineHeight: 1.7, maxWidth: "960px", margin: "0 auto" }}>
      <h1>Terms & Conditions</h1>
      <p>
        <strong>Last updated:</strong> July 21, 2026
      </p>
      <p>
        © 2026 VMCREATION. All rights reserved.
      </p>
      <p>
        By using this website, you agree to these terms and to the
        <Link to="/privacy-policy"> Privacy Policy</Link>.
      </p>

      <h2>Cookies and storage consent</h2>
      <ul>
        <li>Strictly necessary and functional storage is used for core functionality, security, sign-in state, and saved settings or game progress.</li>
        <li>Optional analytics and marketing storage is used only if you explicitly consent.</li>
        <li>You can change your consent choices at any time through Cookie Settings on the website.</li>
      </ul>

      <h2>User responsibilities</h2>
      <ul>
        <li>Use this website lawfully and do not interfere with service availability or security.</li>
        <li>Protect your account credentials, device security, and recovery phrases where applicable.</li>
        <li>Cite this website appropriately in any work or publication that references its content.</li>
      </ul>

      <h2>Chat and sensitive information</h2>
      <p>
        Do not use chat or storage features for highly sensitive legal, medical, financial,
        or safety-critical information.
      </p>

      <h2>Age notice</h2>
      <p>
        <strong>The AI features, chat, and accounts are for people aged 18 or older only.</strong>{" "}
        They are not for school students or anyone under 18. If you are under 18, do not use them.
        By using them you confirm you are 18 or older. AI output may be inaccurate and is not
        professional advice. See the Privacy Policy for details.
      </p>

      <p>
        Continued use of this website means you accept these terms and any future updates posted here.
      </p>
    </div>
  );
}

export default TermsAndConditions;
